<template>
  <v-container fluid>
    <!-- <SidebarNavigation /> -->

    <v-card>
      <v-tabs v-model="tab" @change="onTabChange">
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab v-for="item in tabItems" :key="item" :disabled="false">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>

    <v-card>
      <v-tabs-items v-model="tab">
        <!-- tab data karyawan -->
        <v-tab-item>
          <v-row class="pt-3 px-2">
            <v-col>
              <v-form v-model="isFormValidDataEmployee" @submit.prevent>
                <v-text-field
                  v-model="email"
                  label="Email"
                  :rules="[
                    (v) => !!v || 'Email tidak boleh kosong!',
                    (v) =>
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                        v
                      ) || 'Email tidak valid!',
                  ]"
                ></v-text-field>
                <v-text-field
                  :rules="[(v) => !!v || 'Nama tidak boleh kosong !']"
                  v-model="name"
                  label="Nama"
                ></v-text-field>
                <v-text-field
                  :rules="[(v) => !!v || 'Nik tidak boleh kosong !']"
                  type="number"
                  v-model="nik"
                  label="NIK"
                ></v-text-field>

                <v-autocomplete
                  :items="divisionsOptionsSort"
                  item-text="mst_division_name"
                  item-value="mst_division_id"
                  label="Department"
                  dense
                  outlined
                  :rules="[
                    (v) => !!v || 'Department tidak boleh kosong !',
                    (v) => v !== 0 || 'Department tidak boleh 0 !',
                  ]"
                  v-model="selectedDivisionId"
                ></v-autocomplete>

                <v-autocomplete
                  item-text="mst_position_name"
                  item-value="mst_position_id"
                  :items="positionOptionsSort"
                  v-model="selectedPositionId"
                  label="Posisi Jabatan"
                  dense
                  outlined
                  :rules="[
                    (v) => !!v || 'Posisi Jabatan tidak boleh kosong !',
                    (v) => v !== 0 || 'Posisi Jabatan tidak boleh 0 !',
                  ]"
                ></v-autocomplete>

                <v-autocomplete
                  :rules="[
                    (v) => !!v || 'Perusahaan tidak boleh kosong !',
                    (v) => v !== 0 || 'Perusahaan tidak boleh 0 !',
                  ]"
                  item-text="mst_corporate_name"
                  item-value="mst_corporate_id"
                  :items="corporateOptions"
                  v-model="selectedCorporateId"
                  label="Perusahaan"
                  dense
                  outlined
                ></v-autocomplete>

                <v-autocomplete
                  v-show="isShowSite"
                  :rules="[
                    (v) => !!v || 'Lokasi kerja tidak boleh kosong !',
                    (v) => v !== 0 || 'Lokasi kerja tidak boleh 0 !',
                  ]"
                  item-text="mst_site_name"
                  item-value="mst_site_id"
                  :items="siteOptions"
                  v-model="selectedSiteId"
                  label="Lokasi Kerja"
                  dense
                  outlined
                ></v-autocomplete>
              </v-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :disabled="!isFormValidDataEmployee"
                  @click="next(1)"
                  >Lanjut <span class="mdi mdi-arrow-right"></span
                ></v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- tab tambah ide -->
        <v-tab-item>
          <v-row class="pt-3 px-1" justify="end" align="top">
            <!-- Tombol Tambah -->
            <v-col cols="12" md="auto">
              <v-btn class="primary" @click="openDialog()"> Tambah </v-btn>
            </v-col>

            <v-col cols="auto" style="max-width: 180px">
              <v-menu
                v-model="pagination.startMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    v-model="pagination.startDate"
                    label="Tanggal Awal"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="pagination.startDate"
                  @input="onDateChange('start')"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="auto" style="max-width: 180px">
              <v-menu
                v-model="pagination.endMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="pagination.endDate"
                    label="Tanggal Akhir"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="pagination.endDate"
                  @input="onDateChange"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Search -->
            <v-col cols="auto" style="max-width: 180px">
              <v-text-field
                v-model="pagination.search"
                label="Search"
                append-icon="mdi-magnify"
                dense
                hide-details
                class="search-input"
                style="max-width: 250px"
                outlined
                @input="debouncedSearch"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                mobile-breakpoint="0"
                fixed-header
                dense
                class="elevation-5"
                :headers="tableHeaders"
                :items="suggestionsList"
                :items-per-page.sync="pagination.itemsPerPage"
                :page.sync="pagination.page"
                :sort-by="pagination.sortBy"
                :sort-desc="pagination.sortDesc"
                :loading="isLoading"
                :server-items-length="totalSuggestions"
                item-key="id"
                @update:page="updateQuery('page', $event)"
                @update:items-per-page="updateQuery('itemsPerPage', $event)"
                @update:sort-by="updateQuery('sortBy', $event)"
                @update:sort-desc="updateQuery('sortDesc', $event)"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>
                        <span
                          color="transparent"
                          class="text-none"
                          @click="openDialogSuggestionDetail(item)"
                        >
                          {{ item.title }}
                        </span>
                      </td>
                      <td>{{ item.suggestion_category_name }}</td>
                      <td>
                        <span @click="openDialogPic(item)">{{
                          item.step_name ? `${item.step_name}` : ""
                        }}</span>
                      </td>
                      <td>{{ item.last_status }}</td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="item.action_history_approval === 't'"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="openDialogApproval(item.id)"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          Tampilkan
                        </v-tooltip>
                      </td>
                      <td>
                        <div v-if="item.file_names">
                          <v-icon
                            v-for="(fileName, index) in fileList(
                              item.file_names
                            )"
                            :key="`icon-${index}`"
                            color="primary"
                            @click="downloadAttachment(item.id, fileName)"
                          >
                            {{ getFileIcon(fileName) }}
                          </v-icon>
                        </div>
                      </td>

                      <td>
                        <v-tooltip
                          v-if="
                            item.last_status ===
                            'Approved Operation Excellence & Improvement'
                          "
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="openDialogUploadImplement(item.id)"
                            >
                              <v-icon color="primary">mdi-upload</v-icon>
                            </v-btn>
                          </template>
                          Upload Bukti Implementasi
                        </v-tooltip>

                        <div v-else-if="item.file_names_bukti">
                          <v-icon
                            v-for="(fileName, index) in fileList(
                              item.file_names_bukti
                            )"
                            :key="`icon-${index}`"
                            color="primary"
                            @click="downloadBukti(item.id, fileName)"
                          >
                            {{ getFileIcon(fileName) }}
                          </v-icon>
                        </div>
                      </td>

                      <td>
                        <div v-if="item.file_names_materi">
                          <v-icon
                            v-for="(fileName, index) in fileList(
                              item.file_names_materi
                            )"
                            :key="`icon-${index}`"
                            color="primary"
                            @click="downloadMateri(item.id, fileName)"
                          >
                            {{ getFileIcon(fileName) }}
                          </v-icon>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="openDialogUploadMateriUpdate(item.id)"
                              >
                                <v-icon color="primary">mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            Edit
                          </v-tooltip>
                        </div>

                        <div v-else-if="item.last_status == 'Implemented'">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="openDialogUploadMateri(item.id)"
                              >
                                <v-icon color="primary">mdi-upload</v-icon>
                              </v-btn>
                            </template>
                            Upload Materi Presentasi
                          </v-tooltip>
                        </div>
                      </td>

                      <td>
                        <div class="small-font">
                          {{ item.created_by_name }}
                        </div>
                        <div class="small-font">
                          {{ item.created_on }}
                        </div>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-if="
                                item.last_status == 'waiting approval' ||
                                item.last_status == 'need to analysis'
                              "
                              color="primary"
                              icon
                              @click="openDialogUpdate(item)"
                              v-bind="attrs"
                              v-on="on"
                              x-small
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          Ubah
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" @click="next(0)"
                  ><span class="mdi mdi-arrow-left"></span> Kembali
                </v-btn>
                <v-btn color="primary" @click="next(2)"
                  >Lanjut <span class="mdi mdi-arrow-right"></span
                ></v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- tab point-->
        <v-tab-item>
          <v-row>
            <v-col xs="12" sm="12" md="4" lg="3" class="mt-4 custom-border">
              <v-card-subtitle class="text-center">
                <v-icon color="green">mdi-wallet</v-icon>
                <span class="text-h6 font-weight-bold green--text">
                  {{ saldo_point.toLocaleString() }} Point
                </span>
              </v-card-subtitle>

              <v-divider class="my-4"></v-divider>

              <v-form v-model="isValid" class="mb-4" @submit.prevent>
                <v-text-field
                  v-model="formatted"
                  label="Jumlah Poin"
                  type="text"
                  class="mt-2"
                  outlined
                  dense
                  :rules="[
                    (v) => !!v || 'Jumlah poin tidak boleh kosong!',
                    (v) => v > 0 || 'Minimal 1 poin',
                    (v) =>
                      /^[0-9]+$/.test(v.replace(/\./g, '')) ||
                      'Hanya boleh angka!',
                    (v) =>
                      parseInt(v.replace(/\./g, ''), 10) > 0 ||
                      'Jumlah poin harus lebih dari 0!',
                    (v) =>
                      parseInt(v.replace(/\./g, ''), 10) <= saldo_point ||
                      'Point tidak mencukupi!',
                  ]"
                />

                <v-alert
                  v-if="exchangePoints.toLocaleString()"
                  type="warning"
                  dense
                  class="text-center soft-alert"
                >
                  Anda akan mendapatkan
                  <strong class="green--text"
                    >Rp{{ convertedAmount.toLocaleString() }}</strong
                  >
                </v-alert>

                <v-btn
                  :disabled="!isValid"
                  color="blue-lighten-2"
                  block
                  class="mt-3 soft-button"
                  @click="confirmExchange"
                >
                  <v-icon left>mdi-swap-horizontal</v-icon>
                  Tukarkan Poin
                </v-btn>
              </v-form>
            </v-col>

            <v-col xs="12" sm="12" md="7" lg="8" class="mt-4 custom-border">
              <v-row class="pt-3">
                <!-- <v-col cols="12" md="3" class="pa-1">
                  <v-menu
                    v-model="pagination.startMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        readonly
                        v-model="pagination.startDate"
                        label="Tanggal Awal"
                        v-bind="attrs"
                        v-on="on"
                        dense
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pagination.startDate"
                      @input="onDateChange('start')"
                      locale="id"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="3" class="pa-1">
                  <v-menu
                    v-model="pagination.endMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="pagination.endDate"
                        label="Tanggal Akhir"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pagination.endDate"
                      @input="onDateChange"
                      locale="id"
                    ></v-date-picker>
                  </v-menu>
                </v-col> -->

                <!-- <v-col cols="12" md="3" class="pa-1">
                  <v-text-field
                    v-model="pagination.search"
                    label="Search"
                    append-icon="mdi-magnify"
                    dense
                    hide-details
                    class="search-input"
                    outlined
                    @input="debouncedSearch"
                  ></v-text-field>
                </v-col> -->
              </v-row>

              <v-row>
                <v-col>
                  <v-data-table
                    mobile-breakpoint="0"
                    fixed-header
                    dense
                    class="elevation-5"
                    :headers="tableHeadersRedeem"
                    :items="pointRedeemList"
                    :items-per-page.sync="paginationRedeem.itemsPerPage"
                    :page.sync="paginationRedeem.page"
                    :sort-by="paginationRedeem.sortBy"
                    :sort-desc="paginationRedeem.sortDesc"
                    :loading="isLoading"
                    :server-items-length="totalPointRedeem"
                    item-key="id"
                    @update:page="updateQueryRedeem('page', $event)"
                    @update:items-per-page="
                      updateQueryRedeem('itemsPerPage', $event)
                    "
                    @update:sort-by="updateQueryRedeem('sortBy', $event)"
                    @update:sort-desc="updateQueryRedeem('sortDesc', $event)"
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="item in items" :key="item.id">
                          <td>
                            <div
                              v-if="item.type === 'earn'"
                              style="color: darkcyan"
                            >
                              {{ item.points.toLocaleString() }}
                              <small>{{ ` - (${item.noted_earn})` }}</small>
                            </div>
                            <div v-else style="color: red">
                              {{ item.points.toLocaleString() }}
                            </div>
                          </td>
                          <td>
                            Rp {{ parseInt(item.amount).toLocaleString() }}
                          </td>
                          <!-- <td>
                            <v-tooltip>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                  @click="openDialogToken(item)"
                                >
                                  <v-icon color="primary">mdi-eye</v-icon>
                                </v-btn>
                              </template>
                              Lihat Token
                            </v-tooltip>
                          </td> -->
                          <td>{{ item.status }}</td>

                          <td>
                            {{ item.created_on }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" @click="next(1)"
                  ><span class="mdi mdi-arrow-left"></span> Kembali
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- create -->
    <v-dialog v-model="isDialogOpen" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValid">
            <v-autocomplete
              :items="suggestionCategoryOptions"
              item-text="name"
              item-value="id"
              label="Kategori"
              dense
              outlined
              v-model="selectedSuggestionCategoryId"
              :rules="[(v) => !!v || 'Pilih kategory terlebih dahulu !']"
              ><template v-slot:item="data">
                <div class="d-flex flex-column">
                  <span class="font-weight-medium text-body-2">{{
                    data.item.name
                  }}</span>
                  <span class="text-caption text--secondary">{{
                    data.item.description
                  }}</span>
                </div>
              </template></v-autocomplete
            >
            <v-text-field
              v-model="suggestionFormData.title"
              label="Judul"
              required
              :rules="[(v) => !!v || 'Judul tidak boleh kosong !']"
            ></v-text-field>
            <v-textarea
              v-model="suggestionFormData.description"
              label="Latar belakang / Uraian masalah"
              require
              :rules="[(v) => !!v || 'Latar belakang tidak boleh kosong !']"
            ></v-textarea>
            <v-textarea
              v-model="suggestionFormData.suggestions"
              label="Solusi"
              type="suggestions"
              :rules="[(v) => !!v || 'Solusi tidak boleh kosong !']"
              required
            ></v-textarea>
            <v-text-field
              v-model="formattedBenefit"
              label="Potensi Benefit"
              type="text"
              :rules="[
                (v) => !!v || 'Benefit tidak boleh kosong',
                (v) =>
                  parseInt(v.replace(/\./g, '')) >= 0 ||
                  'Benefit harus minimal 0',
              ]"
            />
            <v-textarea
              v-model="suggestionFormData.noted"
              label="Keterangan Biaya"
            ></v-textarea>
            <v-file-input
              v-model="suggestionFormData.files"
              label="Lampiran Perhitungan (optional)"
              :accept="'.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.mp4,.avi,.mkv'"
              :rules="[
                (v) => !!v || 'File tidak boleh kosong',
                (v) =>
                  isValidFileType(v) ||
                  'File harus berupa Word, PDF, Excel, PowerPoint, JPEG, PNG, atau Video',
              ]"
              outlined
              dense
              multiple
              hint="Anda dapat memilih lebih dari satu file dengan menekan Ctrl (Windows) atau Command (Mac) saat memilih file. Total ukuran file yang dipilih tidak boleh melebihi 10 MB."
              persistent-hint
            ></v-file-input>
            <ul>
              <li
                v-for="(file, index) in suggestionFormData.files"
                :key="index"
              >
                {{ file.name }}
              </li>
            </ul>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpen = false">Cancel</v-btn>
          <v-btn color="primary" :disabled="!isFormValid" @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- update -->
    <v-dialog v-model="isDialogOpenUpdate" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUpdate">
            <v-autocomplete
              :items="suggestionCategoryOptions"
              item-text="name"
              item-value="id"
              label="Kategori"
              dense
              outlined
              v-model="selectedSuggestionCategoryId"
              :rules="[(v) => !!v || 'Pilih kategory terlebih dahulu !']"
              ><template v-slot:item="data">
                <div class="d-flex flex-column">
                  <span class="font-weight-medium text-body-2">{{
                    data.item.name
                  }}</span>
                  <span class="text-caption text--secondary">{{
                    data.item.description
                  }}</span>
                </div>
              </template></v-autocomplete
            >
            <v-text-field
              v-model="suggestionFormDataUpdate.title"
              label="Judul"
              required
              :rules="[(v) => !!v || 'Judul tidak boleh kosong !']"
            ></v-text-field>
            <v-textarea
              v-model="suggestionFormDataUpdate.description"
              label="Latar belakang / Uraian masalah"
              require
              :rules="[(v) => !!v || 'Latar belakang tidak boleh kosong !']"
            ></v-textarea>
            <v-textarea
              v-model="suggestionFormDataUpdate.suggestions"
              label="Solusi"
              type="suggestions"
              :rules="[(v) => !!v || 'Solusi tidak boleh kosong !']"
              required
            ></v-textarea>
            <v-text-field
              v-model="formattedBenefitUpdate"
              label="Potensi Benefit"
              type="text"
              :rules="[
                (v) => !!v || 'Benefit tidak boleh kosong',
                (v) =>
                  parseInt(v.replace(/\./g, '')) >= 0 ||
                  'Benefit harus minimal 0',
              ]"
            />
            <v-textarea
              v-model="suggestionFormDataUpdate.noted"
              label="Keterangan Biaya"
            ></v-textarea>
            <v-file-input
              v-model="suggestionFormDataUpdate.files"
              label="Lampiran Perhitungan (optional)"
              :accept="'.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.mp4,.avi,.mkv'"
              :rules="[
                (v) => !!v || 'File tidak boleh kosong',
                (v) =>
                  isValidFileType(v) ||
                  'File harus berupa Word, PDF, Excel, PowerPoint, JPEG, PNG, atau Video',
              ]"
              outlined
              dense
              multiple
              hint="Anda dapat memilih lebih dari satu file dengan menekan Ctrl (Windows) atau Command (Mac) saat memilih file. Total ukuran file yang dipilih tidak boleh melebihi 10 MB."
              persistent-hint
            ></v-file-input>
            <ul>
              <li
                v-for="(file, index) in suggestionFormDataUpdate.files"
                :key="index"
              >
                {{ file.name }}
              </li>
            </ul>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenUpdate = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUpdate"
            @click="submitUpdate"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- delete -->
    <v-dialog v-model="isDialogOpenDelete" max-width="400px">
      <v-card>
        <v-card-title class="headline">Konfirmasi Hapus</v-card-title>
        <v-card-text>
          Yakin ingin menghapus {{ selectedSuggestion.title }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="submitDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Riwayat Persetujuan -->
    <v-dialog v-model="isDialogOpenApproval" max-width="700px">
      <v-card>
        <v-card-title class="headline">Riwayat Persetujuan</v-card-title>
        <v-data-table
          mobile-breakpoint="0"
          :headers="tableHeadersApproval"
          :items="approvalList"
          class="elevation-1"
        >
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- upload implement -->
    <v-dialog v-model="isDialogOpenUploadImplement" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUploadImplement">
            <v-row>
              <v-col class="text-right">
                <a href="" @click="downloadTemplateImplementasi($event)">
                  Download Template Implementasi
                </a>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      @click="downloadTemplateImplementasi($event)"
                    >
                      <v-icon color="primary">mdi mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>
                  Download Template Implementasi
                </v-tooltip>
              </v-col>
            </v-row>
            <v-file-input
              v-model="implementUploadFormData.files"
              label="Upload Bukti Implementasi"
              :accept="'.xls,.xlsx'"
              :rules="[(v) => !!v || 'File tidak boleh kosong']"
              outlined
              dense
              hint="Total ukuran file yang dipilih tidak boleh melebihi 10 MB."
              persistent-hint
            ></v-file-input>
            <ul>
              <li
                v-for="(file, index) in implementUploadFormData.files"
                :key="index"
              >
                {{ file.name }}
              </li>
            </ul>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenUploadImplement = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUploadImplement"
            @click="submitUploadImplement"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- suggestion detail -->
    <v-dialog v-model="isDialogOpenSuggestionDetail" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            readonly
            :items="suggestionCategoryOptions"
            item-text="name"
            item-value="id"
            label="Kategori"
            dense
            outlined
            v-model="selectedSuggestionCategoryId"
          ></v-autocomplete>
          <v-text-field
            readonly
            v-model="suggestionDetail.title"
            label="Judul"
            required
          ></v-text-field>
          <v-textarea
            v-model="suggestionDetail.description"
            label="Latar belakang / Uraian masalah"
            require
            readonly
          ></v-textarea>
          <v-textarea
            v-model="suggestionDetail.suggestions"
            label="Solusi"
            type="suggestions"
            readonly
          ></v-textarea>
          <v-text-field
            v-model="formattedBenefitDetail"
            label="Potensi Benefit"
            type="text"
            readonly
          >
          </v-text-field>

          <v-textarea
            v-model="suggestionDetail.noted"
            label="Keterangan Biaya"
            readonly
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenSuggestionDetail = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- List Pic -->
    <v-dialog v-model="isDialogOpenPic" max-width="500px">
      <v-card>
        <v-card-title class="headline">Approver</v-card-title>
        <v-data-table
          mobile-breakpoint="0"
          :headers="tableHeadersPic"
          :items="listPic"
          class="elevation-1"
        >
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- upload materi -->
    <v-dialog v-model="isDialogOpenUploadMateri" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUploadMateri">
            <v-row>
              <v-col class="text-right">
                <a href="" @click="downloadTemplateMateri($event)">
                  Download Template Materi Presentasi
                </a>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      @click="downloadTemplateMateri($event)"
                    >
                      <v-icon color="primary"
                        >mdi mdi-microsoft-powerpoint</v-icon
                      >
                    </v-btn>
                  </template>
                  Download Template Materi Presentasi
                </v-tooltip>
              </v-col>
            </v-row>
            <v-file-input
              v-model="materiUploadFormData.files"
              label="Klik disini untuk upload."
              :accept="'.pptx'"
              :rules="[(v) => !!v || 'File tidak boleh kosong']"
              outlined
              dense
              hint="Total ukuran file yang dipilih tidak boleh melebihi 10 MB."
              persistent-hint
            ></v-file-input>
            <ul>
              <li
                v-for="(file, index) in materiUploadFormData.files"
                :key="index"
              >
                {{ file.name }}
              </li>
            </ul>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenUploadMateri = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUploadMateri"
            @click="submitUploadMateri"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Konfirmasi -->
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">
          Konfirmasi Penukaran
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-center my-4">
          Anda yakin ingin menukar
          <strong class="blue--text">{{
            exchangePoints.toLocaleString()
          }}</strong>
          poin dengan jumlah uang
          <strong class="green--text"
            >Rp{{ convertedAmount.toLocaleString() }}</strong
          >?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="dialog = false">Batal</v-btn>
          <v-btn color="primary" @click="submitRedeem">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog point token -->
    <v-dialog v-model="dialogPointToken" max-width="600px">
      <v-card>
        <v-card-title class="headline text-center">
          Selamat, {{ name }}
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <p>Token berhasil dikirim ke alamat email anda "{{ email }}""</p>
            <p>
              Berikan kode token ke tim improvement untuk menukarkan dengan uang
              tunai.
            </p>
            <!-- <p>
              Token ini berlaku dalam waktu 24 Jam sampai
              <strong>{{ point_token_expires }}</strong
              >.
            </p> -->
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="dialogPointToken = false">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import apiUnlogin from "@/utils/apiUnlogin";
// import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import { getLast30Days } from "@/utils/date";

export default {
  components: {
    // SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      tableHeadersRedeem: [
        { text: "Point", align: "center", value: "point" },
        { text: "Amount", align: "center", value: "amount" },
        // { text: "Token", align: "center", value: "token" },
        { text: "Status", align: "center", value: "status" },
        { text: "Dibuat", align: "center", value: "id" },
      ],
      paginationRedeem: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: false,
        startMenu: false,
        endMenu: false,
        startDate: getLast30Days().start,
        endDate: getLast30Days().end,
        search: "",
      },
      pointRedeemList: [],
      pointToken: "",
      pointTokenExpires: null,
      totalPointRedeem: 0,
      saldo_point: 0,
      exchangePoints: 0, // Jumlah poin yang ingin ditukar
      pointConvert: 0, // 1 poin = 100 rupiah
      dialog: false,
      dialogPointToken: false,
      isValid: false,
      awsObjectUrl: process.env.VUE_APP_AWS_OBJECT_URL,
      awsPath: process.env.VUE_APP_AWS_PATH,
      selectedSuggestion: {},
      tab: 0,
      tabItems: ["Data Karyawan", "Suggestion", "My Point"],
      tableHeaders: [
        { text: "Judul", align: "center", value: "title", sortable: false },
        {
          text: "Kategori",
          align: "center",
          value: "category",
          sortable: false,
        },
        {
          text: "PIC Persetujuan",
          align: "center",
          value: "step_name",
          sortable: false,
        },
        {
          text: "Status Terakhir",
          align: "center",
          value: "last_status",
          sortable: false,
        },
        {
          text: "Riwayat Persetujuan",

          align: "center",
          value: "history_approval",
          sortable: false,
        },
        {
          text: "Lampiran Perhitungan",

          align: "center",
          value: "lampiran_perhitungan",
          sortable: false,
        },
        {
          text: "Bukti Implementasi",

          align: "center",
          value: "bukti",
        },
        {
          text: "Materi Presentasi",

          align: "center",
          value: "materi",
        },
        { text: "Dibuat Oleh", align: "center", value: "id", sortable: false },
        { text: "Aksi", align: "center", value: "actions", sortable: false },
      ],
      tableHeadersApproval: [
        { text: "Name", align: "center", value: "step_name" },
        { text: "Status", align: "center", value: "status" },
        { text: "Catatan", align: "center", value: "comments" },
        { text: "Di Setujui Oleh", align: "center", value: "created_by_name" },
        { text: "Tanggal", align: "center", value: "created_on" },
      ],
      tableHeadersPic: [
        { text: "Nama", align: "center", value: "mst_employee_name" },
        { text: "Email", align: "center", value: "mst_employee_email" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: false,
        startMenu: false,
        endMenu: false,
        startDate: getLast30Days().start,
        endDate: getLast30Days().end,
        search: "",
      },
      totalSuggestions: 0,
      suggestionsList: [],
      approvalList: [],
      listPic: [],
      isLoading: false,
      dialogTitle: "Tambah Suggestion",
      isFormValidDataEmployee: false,
      isFormValid: false,
      isFormValidUpdate: false,
      isFormValidUploadImplement: false,
      isFormValidUploadMateri: false,
      suggestionCategoryOptions: null,
      suggestionDetail: {
        id: null,
        suggestion_category_id: null,
        title: "",
        description: "",
        suggestions: "",
        benefit: 0,
        noted: "",
      },
      suggestionFormData: {
        suggestion_category_id: null,
        title: "",
        description: "",
        suggestions: "",
        benefit: 0,
        noted: "",
        files: [],
      },
      suggestionFormDataUpdate: {
        id: null,
        suggestion_category_id: null,
        title: "",
        description: "",
        suggestions: "",
        benefit: 0,
        noted: "",
        files: [],
      },
      implementUploadFormData: {
        files: null,
      },
      materiUploadFormData: {
        files: [],
      },
      isDialogOpen: false,
      isDialogOpenUpdate: false,
      isDialogOpenDelete: false,
      isDialogOpenApproval: false,
      isDialogOpenPic: false,
      isDialogOpenUploadMateri: false,
      isDialogOpenUploadImplement: false,
      isDialogOpenSuggestionDetail: false,
      isShowSite: true,
      selectedSuggestionCategoryId: null,
      divisionsOptions: null,
      divisionsOptionsSort: [],
      positionOptions: null,
      positionOptionsSort: [],
      corporateOptions: null,
      siteOptions: null,
      selectedDivisionId: null,
      selectedPositionId: null,
      selectedCorporateId: null,
      selectedSiteId: null,
      nik: null,
      email: null,
      name: null,
    };
  },
  methods: {
    async fetchSaldoPointByEmail() {
      // console.log(this.email);
      apiUnlogin
        .get(`/points-unlogin/saldo?email=${this.email}`)
        .then(({ data }) => {
          this.saldo_point = parseInt(data.data.saldo_point);
          // console.log(data.data.saldo_point);
        })
        .catch((error) => {
          console.error("Error fetching employee:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchConvert() {
      apiUnlogin
        .get(`/parameters/Convert`)
        .then(({ data }) => {
          // console.log(data.data[0].value);
          this.saldo_point_convert = parseInt(data.data[0].value);
          // console.log(data);
        })
        .catch((error) => {
          console.error("Error fetching convert:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchRedeemPoint() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.paginationRedeem.page,
        limit:
          parseInt(query.itemsPerPage) || this.paginationRedeem.itemsPerPage,
        search: query.search || this.paginationRedeem.search,
        sortBy: query.sortBy || this.paginationRedeem.sortBy || "id",
        sortDesc: query.sortDesc || this.paginationRedeem.sortDesc || true,
        email: query.email || this.email,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
      };

      await apiUnlogin
        .get("/points-unlogin/redeem", { params })
        .then(({ data }) => {
          // console.log(data);
          this.pointRedeemList = data.data.data;
          this.totalPointRedeem = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching penukaran:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    confirmExchange() {
      this.dialog = true;
    },
    async copyToken() {
      try {
        await navigator.clipboard.writeText(this.pointToken);
        store.dispatch("triggerSnackbar", {
          message: "Token berhasil disalin! ✅",
          isSuccess: true,
        });
      } catch (err) {
        store.dispatch("triggerSnackbar", {
          message: "Gagal menyalin token ❌",
          isSuccess: false,
        });
      }
    },
    openDialogToken(params) {
      this.pointToken = params.point_token;
      this.pointTokenExpires = params.pointTokenExpires;
      this.dialogPointToken = true;
    },
    submitRedeem() {
      store.dispatch("showLoading");
      const payload = {
        exchangePoints: this.exchangePoints,
        amount: this.convertedAmount,
        mst_employee_email: this.email,
        mst_employee_name: this.name,
        mst_corporate_id: this.selectedCorporateId,
        mst_site_id: this.selectedSiteId,
      };
      apiUnlogin
        .post("/points-unlogin/redeem", payload)
        .then((response) => {
          const message = response.data.message;
          // console.log(response.data);
          this.fetchConvert();
          this.fetchSaldoPointByEmail();
          this.fetchRedeemPoint();
          this.exchangePoints = 0;
          this.dialog = false;
          this.point_token = response.data.data.pointToken;
          this.point_token_expires = response.data.data.pointTokenExpires;
          // this.dialogPointToken = true;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save redeem point!";
          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    debouncedSearchRedeem() {
      this.updateQueryRedeem("search", this.paginationRedeem.search);
    },
    onDateChangeRedeem(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.paginationRedeem.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.paginationRedeem.endDate); // Update endDate
      }
    },
    updatePaginationRedeem(query) {
      this.paginationRedeem.page = parseInt(query.page) || 1;
      this.paginationRedeem.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.paginationRedeem.sortBy = query.sortBy || "id";
      this.paginationRedeem.sortDesc = query.sortDesc === "true" ? true : false;
      this.paginationRedeem.search =
        query.search || this.paginationRedeem.search || "";
      this.paginationRedeem.startDate =
        query.startDate || this.paginationRedeem.startDate;
      this.paginationRedeem.endDate =
        query.endDate || this.paginationRedeem.endDate;
    },
    updateQueryRedeem(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePaginationRedeem(this.$route.query);
    },
    async fetchDivisions() {
      this.isDivisionsLoading = true;
      apiUnlogin
        .get("/divisions")
        .then(({ data }) => {
          this.divisionsOptions = data.data.data;
          // this.divisionsOptions = [];
          // console.log(this.divisionsOptions.length);
          for (let i = 0; i < this.divisionsOptions.length; i++) {
            if (
              this.divisionsOptions[i].mst_division_name === "Transportation" ||
              this.divisionsOptions[i].mst_division_name ===
                "Operation & Warehouse"
            ) {
              this.divisionsOptionsSort.push({
                mst_division_id: this.divisionsOptions[i].mst_division_id,
                mst_division_name: this.divisionsOptions[i].mst_division_name,
              });
            }
          }
          for (let i = 0; i < this.divisionsOptions.length; i++) {
            if (
              this.divisionsOptions[i].mst_division_name !== "Transportation" &&
              this.divisionsOptions[i].mst_division_name !==
                "Operation & Warehouse"
            ) {
              this.divisionsOptionsSort.push({
                mst_division_id: this.divisionsOptions[i].mst_division_id,
                mst_division_name: this.divisionsOptions[i].mst_division_name,
              });
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching division:", error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isDivisionsLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchPosition() {
      apiUnlogin
        .get(`/positions?divisionId=${this.selectedDivisionId}`)
        .then(({ data }) => {
          this.positionOptions = data.data.data;
          this.positionOptionsSort = [];

          for (let i = 0; i < this.positionOptions.length; i++) {
            if (this.positionOptions[i].mst_position_name === "Driver") {
              this.positionOptionsSort.push({
                mst_position_id: this.positionOptions[i].mst_position_id,
                mst_position_name: this.positionOptions[i].mst_position_name,
              });
            }
          }
          for (let i = 0; i < this.positionOptions.length; i++) {
            if (this.positionOptions[i].mst_position_name !== "Driver") {
              this.positionOptionsSort.push({
                mst_position_id: this.positionOptions[i].mst_position_id,
                mst_position_name: this.positionOptions[i].mst_position_name,
              });
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchCorporates() {
      apiUnlogin
        .get("/corporates?isOutsourcing=1")
        .then(({ data }) => {
          this.corporateOptions = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching corporate:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchSites() {
      // console.log("test");
      apiUnlogin
        .get("/sites?corporateId=2")
        .then(({ data }) => {
          this.siteOptions = data.data.data;
          // if (this.selectedPositionId === 48 && this.selectedDivisionId === 4) {
          //   this.siteOptions.unshift({
          //     mst_site_id: -1,
          //     mst_site_name: "DRIVER",
          //   });
          // }
        })
        .catch((error) => {
          console.error("Error fetching sites:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchSuggestionCategory() {
      apiUnlogin
        .get(`/suggestions-categories`)
        .then(({ data }) => {
          this.suggestionCategoryOptions = data.data.data;
          // console.log(this.suggestionCategoryOptions);
        })
        .catch((error) => {
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchSuggestion() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        nik: query.nik || this.nik,
        email: query.email || this.email,
        outsorchingCorporateId: query.corporateId || this.selectedCorporateId,
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
      };

      // console.log(params);

      await apiUnlogin
        .get("/suggestions-unlogin", { params })
        .then(({ data }) => {
          // console.log(data);
          this.suggestionsList = data.data.data;
          this.totalSuggestions = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    openDialog() {
      this.dialogTitle = "Tambah Suggestion";

      this.isDialogOpen = true;
    },
    openDialogUpdate(params = null) {
      this.selectedSuggestionCategoryId = params.suggestion_category_id;
      this.dialogTitle = "Ubah Suggestion";
      this.suggestionFormDataUpdate = { ...params };
      this.suggestionFormDataUpdate.files = [];
      // console.log(this.suggestionFormDataUpdate);
      this.isDialogOpenUpdate = true;
      this.isSuggestionCategoryLoading = false;
    },
    openDialogApproval(id) {
      apiUnlogin
        .get(`/approvals/by-suggestion-id/${id}`)
        .then(({ data }) => {
          this.approvalList = data.data;
          this.isDialogOpenApproval = true;
        })
        .catch((error) => {
          this.isDialogOpenApproval = true;
          this.approvalList = [];
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    openDialogPic(params) {
      // console.log(params);
      this.listPic = params.list_pic;
      console.log(this.listPic.list_pic);
      this.isDialogOpenPic = true;
      this.isLoading = false;
      store.dispatch("hideLoading");
    },
    openDialogUploadImplement(suggestionId) {
      this.dialogTitle = "Implementasi";
      this.implementUploadFormData = {
        suggestion_id: suggestionId,
        files: null,
      };
      this.isDialogOpenUploadImplement = true;
    },
    openDialogUploadMateri(suggestionId) {
      this.dialogTitle = "Upload Materi Presentasi";
      this.materiUploadFormData = {
        suggestion_id: suggestionId,
        files: null,
      };
      this.isDialogOpenUploadMateri = true;
    },
    openDialogUploadMateriUpdate(suggestionId) {
      this.dialogTitle = "Ubah Materi Presentasi";
      this.materiUploadFormData = {
        suggestion_id: suggestionId,
        files: null,
      };
      this.isDialogOpenUploadMateri = true;
    },
    openDialogDelete(suggestion) {
      this.selectedSuggestion = suggestion; // Menyimpan suggestion yang dipilih
      this.isDialogOpen = true; // Menampilkan dialog konfirmasi
    },
    openDialogSuggestionDetail(params = null) {
      this.selectedSuggestionCategoryId = params.suggestion_category_id;
      this.dialogTitle = "Detail Suggestion";
      this.suggestionDetail = { ...params };
      this.isDialogOpenSuggestionDetail = true;
    },
    downloadAttachment(id, fileName) {
      // console.log(pathName);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/calculation/${id}/${fileName}`,
        "_blank"
      );
    },
    downloadTemplateMateri() {
      // console.log(pathName);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/template/template_materi_presentasi.pptx`,
        "_blank"
      );
    },
    downloadTemplateImplementasi(event) {
      // console.log(pathName);
      event.preventDefault();
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/template/form_verifikasi_&_implementasi.xlsx`,
        "_blank"
      );
    },
    downloadBukti(id, fileName) {
      // console.log(pathName);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/implemented/${id}/${fileName}`,
        "_blank"
      );
    },
    downloadMateri(id, fileName) {
      // console.log(pathName);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/materi/${id}/${fileName}`,
        "_blank"
      );
    },
    fileList(fileNames) {
      return fileNames ? fileNames.split("|") : [];
    },
    getFileIcon(fileName) {
      const extension = fileName.split(".").pop().toLowerCase();
      const icons = {
        xlsx: "mdi-file-excel-outline",
        jpeg: "mdi-image",
        png: "mdi-image",
        jpg: "mdi-image",
        pdf: "mdi-file-pdf-box",
        mp4: "mdi-video-box",
      };
      return icons[extension] || "mdi-file-download-outline";
    },
    goToValidation(id, token) {
      this.$router.push({
        name: "validation",
        params: { id: id, token: token },
      });
    },
    async submit() {
      if (!this.email || this.email.trim() === "") {
        store.dispatch("triggerSnackbar", {
          message: "Email wajib di isi !",
          isSuccess: false,
        });

        return;
      } else if (!this.name || this.name.trim() === "") {
        store.dispatch("triggerSnackbar", {
          message: "Nama wajib di isi !",
          isSuccess: false,
        });

        return;
      } else if (!this.nik || this.nik.trim() === "") {
        store.dispatch("triggerSnackbar", {
          message: "Nik wajib di isi !",
          isSuccess: false,
        });

        return;
      } else if (!this.selectedDivisionId) {
        store.dispatch("triggerSnackbar", {
          message: "Department wajib di isi !",
          isSuccess: false,
        });

        return;
      } else if (!this.selectedPositionId) {
        store.dispatch("triggerSnackbar", {
          message: "Posisi jabatan wajib di isi !",
          isSuccess: false,
        });

        return;
      } else if (!this.selectedCorporateId) {
        store.dispatch("triggerSnackbar", {
          message: "Perusahaan wajib di isi !",
          isSuccess: false,
        });

        return;
      } else if (
        (!this.selectedSiteId ||
          this.selectedSiteId.toString().trim() === "") &&
        this.selectedPositionId !== 48
      ) {
        store.dispatch("triggerSnackbar", {
          message: "Lokasi kerja wajib di isi !",
          isSuccess: false,
        });

        return;
      }

      store.dispatch("showLoading");

      const formData = new FormData();
      formData.append("title", this.suggestionFormData.title);
      formData.append("description", this.suggestionFormData.description);
      formData.append("benefit", this.suggestionFormData.benefit);
      formData.append("noted", this.suggestionFormData.noted);
      formData.append(
        "suggestion_category_id",
        this.selectedSuggestionCategoryId
      );
      formData.append("suggestions", this.suggestionFormData.suggestions);
      this.suggestionFormData.files.forEach((file) => {
        formData.append("files", file);
      });

      formData.append("name", this.name);
      formData.append("nik", this.nik);
      formData.append("email", this.email);
      formData.append("corporateId", this.selectedCorporateId);
      formData.append("divisionId", this.selectedDivisionId);
      formData.append("positionId", this.selectedPositionId);
      formData.append("siteId", this.selectedSiteId);

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      apiUnlogin
        .post("/suggestions-unlogin", formData)
        .then((response) => {
          const message = response.data.message;
          this.fetchSuggestion();
          this.suggestionFormData = {
            id: null,
            title: "",
            description: "",
            benefit: 0,
            noted: "",
            files: [],
          };
          this.isDialogOpen = false;
          this.fetchSuggestion();

          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save suggestion!";

          // console.log(error.response.data);

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", { message, isSuccess: false });
          this.isDialogOpen = false;
          this.fetchSuggestion();

          store.dispatch("hideLoading");
        })
        .finally(() => {
          this.fetchSuggestion();
        });
    },
    async submitUpdate() {
      store.dispatch("showLoading");

      const formData = new FormData();
      formData.append("title", this.suggestionFormDataUpdate.title);
      formData.append("description", this.suggestionFormDataUpdate.description);
      formData.append("benefit", this.suggestionFormDataUpdate.benefit);
      formData.append("noted", this.suggestionFormDataUpdate.noted);
      formData.append(
        "suggestion_category_id",
        this.selectedSuggestionCategoryId
      );
      formData.append("suggestions", this.suggestionFormDataUpdate.suggestions);
      formData.append("id", this.suggestionFormDataUpdate.id);
      this.suggestionFormDataUpdate.files.forEach((file) => {
        formData.append("files", file);
      });

      formData.append("name", this.name);
      formData.append("divisionId", this.selectedDivisionId);
      formData.append("positionId", this.selectedPositionId);
      formData.append("siteId", this.selectedSiteId);

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      apiUnlogin
        .post("/suggestions-unlogin/update", formData)
        .then((response) => {
          const message = response.data.message;
          this.fetchSuggestion();
          this.isDialogOpenUpdate = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to update suggestion!";

          // console.log(error.response.data);

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          this.fetchSuggestion();

          store.dispatch("triggerSnackbar", { message, isSuccess: false });
        })
        .finally(() => {
          this.isLoading = false;
          this.fetchSuggestion();
          store.dispatch("hideLoading");
        });
    },
    async submitUploadImplement() {
      store.dispatch("showLoading");

      if (!this.implementUploadFormData.files) {
        store.dispatch("triggerSnackbar", {
          message: "File tidak boleh kosong !",
          isSuccess: false,
        });
        store.dispatch("hideLoading");
        return;
      }

      const formData = new FormData();

      formData.append(
        "suggestion_id",
        this.implementUploadFormData.suggestion_id
      );

      // this.implementUploadFormData.files.forEach((file) => {
      formData.append("files", this.implementUploadFormData.files);

      // });

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      apiUnlogin
        .post("/suggestions-unlogin/upload-implemented", formData)
        .then((response) => {
          const message = response.data.message;
          this.fetchSuggestion();
          this.isDialogOpenUploadImplement = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save upload implements!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", { message, isSuccess: false });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async submitUploadMateri() {
      store.dispatch("showLoading");

      if (!this.materiUploadFormData.files) {
        store.dispatch("triggerSnackbar", {
          message: "File tidak boleh kosong !",
          isSuccess: false,
        });
        store.dispatch("hideLoading");
        return;
      }

      const formData = new FormData();

      formData.append("suggestion_id", this.materiUploadFormData.suggestion_id);

      formData.append("files", this.materiUploadFormData.files);

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      apiUnlogin
        .post("/suggestions-unlogin/upload-materi", formData)
        .then((response) => {
          const message = response.data.message;
          this.fetchSuggestion();
          this.isDialogOpenUploadMateri = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save upload materis!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", { message, isSuccess: false });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async submitDelete() {
      store.dispatch("showLoading");

      const suggestion = this.selectedSuggestion;

      // Menggunakan POST untuk penghapusan
      apiUnlogin
        .post("/suggestions/delete", { id: suggestion.id }) // Kirimkan ID employee ke backend
        .then((response) => {
          const message =
            response.data.message || "Employee deleted successfully!"; // Pesan sukses

          // Memperbarui data dan menampilkan snackbar dengan pesan sukses
          this.fetchSuggestion();
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });

          // Menutup dialog setelah penghapusan berhasil
          this.isDialogOpen = false;
        })
        .catch((error) => {
          console.error("Error deleting suggestion:", error);
          let message = "Failed to delete suggestion."; // Pesan error default

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend
          } else {
            message = error.message || message; // Pesan error default
          }

          // Menampilkan pesan error
          store.dispatch("triggerSnackbar", { message, isSuccess: true });

          // Menutup dialog jika terjadi error
          this.isDialogOpen = false;
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      // console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
      this.selectedDivisionId =
        parseInt(query.divisionId) || this.selectedDivisionId;
      this.selectedPositionId =
        parseInt(query.positionId) || this.selectedPositionId;
      this.selectedCorporateId =
        parseInt(query.corporateId) || this.selectedCorporateId;
      this.selectedSiteId = parseInt(query.siteId) || this.selectedSiteId;
      this.nik = query.nik || this.nik;
      this.email = query.email || this.email;
      this.name = query.name || this.name;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
    getToday() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Bulan mulai dari 0
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // Format ISO
    },
    onDateChange(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.pagination.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.pagination.endDate); // Update endDate
      }
    },
    next(tab) {
      this.tab = tab;
      this.fetchSuggestion();
      this.fetchSaldoPointByEmail();
      this.fetchConvert();
      this.fetchRedeemPoint();
    },
    onTabChange() {
      this.fetchSuggestion();
      this.fetchSaldoPointByEmail();
      this.fetchConvert();
      this.fetchRedeemPoint();
    },
  },
  watch: {
    pagination: {
      handler: "fetchSuggestion",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
      // immediate: false,
    },
    paginationRedeem: {
      handler: "fetchRedeemPoint",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
      // immediate: false,
    },
    selectedDivisionId() {
      this.fetchPosition();
      this.fetchSites();
      this.updateQuery("divisionId", this.selectedDivisionId); // Update startDate
    },
    selectedPositionId() {
      this.fetchSites();
      if (this.selectedPositionId === 48) {
        this.isShowSite = false;
        this.selectedSiteId = 2;
        if (this.$route.query["siteId"] !== 2) {
          this.$router
            .push({
              query: {
                ...this.$route.query,
                ["siteId"]: 2, // Mengupdate parameter query dengan key dan value
              },
            })
            .catch((err) => {
              // Handle error jika ada (contohnya, karena navigasi yang redundant)
              if (err.name !== "NavigationDuplicated") {
                console.error(err);
              }
            });
        }
      } else {
        this.isShowSite = true;
      }
      this.updateQuery("positionId", this.selectedPositionId); // Update startDate
    },
    selectedCorporateId() {
      this.updateQuery("corporateId", this.selectedCorporateId); // Update startDate
    },
    selectedSiteId() {
      this.updateQuery("siteId", this.selectedSiteId); // Update startDate
    },
    nik() {
      this.updateQuery("nik", this.nik); // Update startDate
    },
    email() {
      this.updateQuery("email", this.email); // Update startDate
    },
    name() {
      this.updateQuery("name", this.name); // Update startDate
    },
  },
  mounted() {
    this.updatePagination(this.$route.query);

    this.fetchConvert();
    this.fetchRedeemPoint();
    store.commit("setTitle", "Suggestion");
    this.fetchDivisions();
    this.fetchCorporates();
    this.fetchSites();
    this.fetchSuggestionCategory();
    this.fetchSuggestion();
    this.fetchSaldoPointByEmail();
  },
  computed: {
    title() {
      return store.state.title; // Mengakses title dari store
    },
    formattedBenefit: {
      get() {
        return new Intl.NumberFormat("id-ID").format(
          this.suggestionFormData.benefit
        );
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.suggestionFormData.benefit =
          parseInt(value.replace(/\./g, "")) || 0;
      },
    },
    formattedBenefitUpdate: {
      get() {
        return new Intl.NumberFormat("id-ID").format(
          this.suggestionFormDataUpdate.benefit
        );
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.suggestionFormDataUpdate.benefit =
          parseInt(value.replace(/\./g, "")) || 0;
      },
    },
    formattedBenefitDetail: {
      get() {
        return new Intl.NumberFormat("id-ID").format(
          this.suggestionDetail.benefit
        );
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.suggestionDetail.benefit = parseInt(value.replace(/\./g, "")) || 0;
      },
    },
    formatted: {
      get() {
        return this.exchangePoints
          ? new Intl.NumberFormat("id-ID").format(this.exchangePoints)
          : "";
      },
      set(value) {
        // Hapus titik (separator ribuan) dan simpan angka asli
        let numericValue = parseInt(value.replace(/\D/g, ""), 10);
        this.exchangePoints = isNaN(numericValue) ? 0 : numericValue;
      },
    },
    convertedAmount() {
      console.log(this.saldo_point_convert);
      return this.exchangePoints
        ? this.exchangePoints * this.saldo_point_convert
        : 0;
    },
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(1),
td:nth-child(2),
td:nth-child(3),
td:nth-child(4),
td:nth-child(5),
td:nth-child(6),
td:nth-child(7),
td:nth-child(8) {
  text-align: center;
}

/* Card lebih soft */
.shadow-soft {
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  border-radius: 12px;
}

/* Tombol lebih soft */
.soft-button {
  border-radius: 8px;
  font-weight: bold;
  transition: background 0.3s ease;
}

.soft-button:hover {
  background-color: #42a5f5 !important; /* Warna biru lebih gelap saat hover */
}

/* Alert lebih nyaman */
.soft-alert {
  background-color: #fff9c4 !important; /* Kuning pastel */
  color: #5d4037 !important; /* Coklat soft */
  border-radius: 8px;
  font-weight: 500;
}

.custom-border {
  border: 2px solid #e6e6e6; /* Border hitam */
  border-radius: 5px; /* Sudut melengkung */
  margin-right: 20px;
  margin-left: 20px;
  margin-top: 20px;
}
</style>
